import { render, staticRenderFns } from "./ReceivedReservationsList.vue?vue&type=template&id=735221da"
import script from "./ReceivedReservationsList.vue?vue&type=script&lang=js"
export * from "./ReceivedReservationsList.vue?vue&type=script&lang=js"
import style0 from "../../components/BankInformation/bkCuenta.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../components/Cuenta/cuentaMenu.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports